require('./brokerTransferPensionPlansInternalView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;

// @Components
const BrokerTransferPensionPlansInternal = require("components/broker/brokerTransferPensionPlansInternal/brokerTransferPensionPlansInternal");
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @Constants
const {
    MYPROFILE_BROKER_URL
} = require('constants/index');

//@Actions
const brokerTransferPensionPlansInternalActions = require('actions/brokerTransferPensionPlansInternal');
const specialistsActions = require('actions/investmentSpecialists');

/**
* Shows Pension Plans transfer wizard
* URL: /myprofile/broker/pensions/transfer/internal
*/
class BrokerTransferPensionPlansInternalView extends React.Component {

    constructor(props) {
        super(props);

        this.onAmountChange = this.onAmountChange.bind(this);
        this.onAccountChange = this.onAccountChange.bind(this);
        this.onOriginPlanChange = this.onOriginPlanChange.bind(this);
        this.onDestinationPlanChange = this.onDestinationPlanChange.bind(this);
        this.onDestinationOptionChange = this.onDestinationOptionChange.bind(this);
        this.onFiscalizationOptionChange = this.onFiscalizationOptionChange.bind(this);
        this.onChangePlanFromSearch = this.onChangePlanFromSearch.bind(this);
        this.onTransferTypeChange = this.onTransferTypeChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const {
            immAccounts,
            immBrokerMyInvestments,
            immBrokerJointContracts,
            requestAllPensionPlans
        } = this.props;
        const immPlans = immBrokerMyInvestments.getIn(['products', 'plans', 'stocks']);
        requestAllPensionPlans(immPlans, immAccounts, immBrokerJointContracts);
    }

    componentWillUnmount() {
        const { resetInternalTransfer } = this.props;
        resetInternalTransfer();
    }

    onAmountChange(value) {
        const { changeAmountInput } = this.props;
        changeAmountInput(value);
    }

    onOriginPlanChange(planId) {
        const {
            immBrokerJointContracts,
            immBrokerTransferPensionPlansInternal,
            onSetOriginPlan
        } = this.props;
        const immPlans = immBrokerTransferPensionPlansInternal.get('walletPlansData');
        onSetOriginPlan(planId, immPlans, immBrokerJointContracts);
    }

    onChangePlanFromSearch(producto) {
        const {
            onSetPlanSelectedFromSearch,
        } = this.props;

        onSetPlanSelectedFromSearch(producto);
    }

    onDestinationPlanChange(planId) {
        const {
            immBrokerJointContracts,
            immBrokerTransferPensionPlansInternal,
            onSetDestinationPlan
        } = this.props;

        const immPlans = immBrokerTransferPensionPlansInternal.get('walletPlansData');
        onSetDestinationPlan(planId, immPlans, immBrokerJointContracts);
    }

    onAccountChange(accountId) {
        const {
            onSetAccount
        } = this.props;

        onSetAccount(accountId);
    }


    onDestinationOptionChange(option) {
        const { changeDestinationOption } = this.props;
        changeDestinationOption(option);
    }

    onTransferTypeChange(option) {
        const { changeTransferTypeOption } = this.props;
        changeTransferTypeOption(option);
    }

    onFiscalizationOptionChange(option) {
        const { changeFiscalizationOption } = this.props;
        changeFiscalizationOption(option);
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleFinish() {
        const { internalTransferConf } = this.props;
        internalTransferConf();
    }

    buildHeader() {
        const subTitle = formatText('brokerTraspassBetweenMyPlans-subtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('breadcrumb-brokerTraspassBetweenMyPlans'),
            }
        ];

        return (
            <div className="row">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="brokerTraspassBetweenMyPlans-title"
                        subtitleLeft={subTitle}
                        breadcrumbConfig={mappingBreadcrumb}
                    >
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
            </div>
        );
    }

    buildBody() {
        const {
            filterDestinationPlans,
            immBrokerMyInvestments,
            getSpecialists,
            immAccounts,
            immBrokerTransferPensionPlansInternal,
            immProfile,
            immInvestmentSpecialists,
            onTelCodeChange,
            onTelChange,
            onCallTimeChange,
            onCommentChange,
            onRequestBrokerCallTimeOptions,
            onRequestCall,
            onReset,
            onSetProfilePhone,
            requestCallFn,
            setAmountRange,
            setVisibleStep,
            setWillCancel,
            setWillLeave,
            toggleDisclaimer,
            validateStep
        } = this.props;

        const immPlans = immBrokerTransferPensionPlansInternal.get('walletPlansData');
        let brokerError = immBrokerMyInvestments.get('errorReceived');
        let bodyContent;

        if(immBrokerTransferPensionPlansInternal.get('isFetching')) {
            bodyContent = <LoadingSection />
        } else {
            bodyContent = (
                <div className="col-xs-12">
                    <BrokerTransferPensionPlansInternal
                        brokerError={brokerError}
                        handleAmountChange={this.onAmountChange}
                        handleFilterDestinationPlans={filterDestinationPlans}
                        handleOriginPlanChange={this.onOriginPlanChange}
                        handleDestinationPlanChange={this.onDestinationPlanChange}
                        handleChangeDestinationOption={this.onDestinationOptionChange}
                        handleChangeTransferTypeOption={this.onTransferTypeChange}
                        handleInputSearchPlanSelected={this.onChangePlanFromSearch}
                        handleChangeFiscalizationOption={this.onFiscalizationOptionChange}
                        handleAccountChange={this.onAccountChange}
                        immAccounts={immAccounts}
                        immBrokerTransferPensionPlansInternal={immBrokerTransferPensionPlansInternal}
                        immInvestmentSpecialists={immInvestmentSpecialists}
                        immPlans={immPlans}
                        immProfile={immProfile}
                        onCancel={this.handleCancel}
                        onFinish={this.handleFinish}
                        onTelCodeChange={onTelCodeChange}
                        onTelChange={onTelChange}
                        onCallTimeChange={onCallTimeChange}
                        onCommentChange={onCommentChange}
                        onRequestBrokerCallTimeOptions={onRequestBrokerCallTimeOptions}
                        onRequestCall={onRequestCall}
                        onSetProfilePhone={onSetProfilePhone}
                        onReset={onReset}
                        getSpecialists={getSpecialists}
                        requestCallFn={requestCallFn}
                        setAmountRange={setAmountRange}
                        setVisibleStep={setVisibleStep}
                        setWillCancel={setWillCancel}
                        setWillLeave={setWillLeave}
                        toggleDisclaimer={toggleDisclaimer}
                        validateStep={validateStep}/>
                </div>
            )
        }

        return (
            <div className="container-fluid">
                <div className="row grid-view--content-position-negative">
                    {bodyContent}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    {this.buildHeader()}
                </div>
                <div className="grid-view__body">
                    {this.buildBody()}
                </div>
            </div>
        )
    }
}

BrokerTransferPensionPlansInternalView.propTypes = {
    changeAmountInput: PropTypes.func.isRequired,
    changeDestinationOption: PropTypes.func.isRequired,
    changeTransferTypeOption: PropTypes.func.isRequired,
    changeFiscalizationOption: PropTypes.func.isRequired,
    filterDestinationPlans: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    immBrokerJointContracts: PropTypes.object.isRequired,
    immBrokerTransferPensionPlansInternal: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immInvestmentSpecialists: PropTypes.object.isRequired,
    internalTransferConf: PropTypes.func.isRequired,
    onSetOriginPlan: PropTypes.func.isRequired,
    onSetPlanSelectedFromSearch: PropTypes.func.isRequired,
    onSetAccount: PropTypes.func.isRequired,
    onSetDestinationPlan: PropTypes.func.isRequired,
    onTelCodeChange: PropTypes.func.isRequired,
    onTelChange: PropTypes.func.isRequired,
    onCallTimeChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onRequestCall: PropTypes.func.isRequired,
    onRequestBrokerCallTimeOptions: PropTypes.func.isRequired,
    requestCallFn: PropTypes.func,
    onSetProfilePhone: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    getSpecialists: PropTypes.func,
    requestAllPensionPlans: PropTypes.func.isRequired,
    resetInternalTransfer: PropTypes.func.isRequired,
    setAmountRange: PropTypes.func.isRequired,
    setAccountChange: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setWillLeave: PropTypes.func.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleModal:PropTypes.func.isRequired,
}

module.exports.constructor = BrokerTransferPensionPlansInternalView;
module.exports.BrokerTransferPensionPlansInternalView = connect(state => ({
    immAccounts: state.accounts,
    immProfile: state.profile,
    immBrokerJointContracts: state.brokerJointContracts,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immPensionPlan: state.brokerPensionPlans,
    immBrokerTransferPensionPlansInternal: state.brokerTransferPensionPlansInternal,
    immInvestmentSpecialists: state.brokerInvestmentSpecialists,
}), {
    changeAmountInput: brokerTransferPensionPlansInternalActions.changeAmountInput,
    changeDestinationOption: brokerTransferPensionPlansInternalActions.changeDestinationOption,
    changeTransferTypeOption: brokerTransferPensionPlansInternalActions.changeTransferTypeOption,
    changeFiscalizationOption: brokerTransferPensionPlansInternalActions.changeFiscalizationOption,
    filterDestinationPlans: brokerTransferPensionPlansInternalActions.filterDestinationPlans,
    handleInputSearchPlanSelected: brokerTransferPensionPlansInternalActions.handleInputSearchPlanSelected,
    internalTransferConf: brokerTransferPensionPlansInternalActions.internalTransferConf,
    onSetOriginPlan: brokerTransferPensionPlansInternalActions.onSetOriginPlan,
    onSetAccount: brokerTransferPensionPlansInternalActions.onSetAccount,
    onSetPlanSelectedFromSearch: brokerTransferPensionPlansInternalActions.onSetPlanSelectedFromSearch,
    onSetDestinationPlan: brokerTransferPensionPlansInternalActions.onSetDestinationPlan,
    requestAllPensionPlans: brokerTransferPensionPlansInternalActions.requestAllPensionPlans,
    resetInternalTransfer: brokerTransferPensionPlansInternalActions.reset,
    setAmountRange: brokerTransferPensionPlansInternalActions.setAmountRange,
    setAccountChange: brokerTransferPensionPlansInternalActions.setAccountChange,
    setVisibleStep: brokerTransferPensionPlansInternalActions.setVisibleStep,
    setWillCancel: brokerTransferPensionPlansInternalActions.setWillCancel,
    setWillLeave: brokerTransferPensionPlansInternalActions.setWillLeave,
    toggleDisclaimer: brokerTransferPensionPlansInternalActions.toggleDisclaimer,
    getSpecialists: specialistsActions.getSpecialists,
    onCallTimeChange: specialistsActions.changeCallTime,
    onCommentChange: specialistsActions.changeComment,
    onRequestBrokerCallTimeOptions: specialistsActions.requestBrokerCallTimeOptions,
    onRequestCall: specialistsActions.requestCall,
    onTelChange: specialistsActions.changeTel,
    onTelCodeChange: specialistsActions.changeTelCode,
    onToggleModal: specialistsActions.toggleModal,
    onSetProfilePhone: specialistsActions.setProfilePhone,
    onReset: specialistsActions.reset,
    validateStep: brokerTransferPensionPlansInternalActions.validateStep
})(withRouter(BrokerTransferPensionPlansInternalView));


